module.exports = __webpack_public_path__ + "res/24-img_business_bg.dad86809b310a09aa30813584c0a8b89.png";